import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import styled from 'styled-components';
import CardSeguimiento from "./CardSeguimiento.jsx";
import DetailContact from './DetailContact';
import { useWindowWidth } from "@react-hook/window-size";
import AgregarContacto from "./AgregarContacto.jsx"
import { getAllSeguimientos, updateContactById, getContactByID } from "../../../../endpoints"
import test from "../../assets/Animacion-nosotros.webm"
import { useLocation, useParams } from "react-router-dom";
import CustomCircularProgress from "../../../../Components/Loading/CustomCircularProgress.jsx"
import {
  ContainerBox,
  DivContentFilters,
  DivRow,
  DivColumn1,
  DivRow1,
  CircleItem,
  ItemAux,
  Input,
  ScrollContainer,
  DivFlexColumn,
  DivBoxContainer,
  VideoCont,
  Text,
  Text1,
  TextItem,
  BtnVerMas
} from './StyledComponents';
const Seguimientos = ({ user }) => {
  const [contacts, setContacts] = useState([]);
  const [contactsFilter, setContactsFilter] = useState([]);
  const [seActualizoContacto, setSeActualizoContacto] = useState(false);
  const params = useParams();
  const onlyWidth = useWindowWidth();
  const [verMas, setVerMas] = useState(false);
  const navigate = useNavigate()
  const [openModalObservaciones, setOpenModalObservaciones] = useState(false);
  const [filterStatusList, SetFilterStatusList] = useState("Todos");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [buscador, setBuscador] = useState();
  const [ultimaPaginaSolicitada, setUltimaPaginaSolicitada] = useState(1);
  const scrollContainerRef = useRef(null);
  const [openAddContact, setOpenAddContact] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModalAddSeguimiento, setOpenModalAddSeguimiento] = useState(false);
  const [idContact, setIdContact] = useState();

  const [selectedContact, setSelectContact] = useState();
  const [totalcontactViewer, setTotalcontactViewer] = useState();
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    telefono: '',
    email: '',
    ramo: '',
    asesorAsignado: '',
  });


  useEffect(() => {
  }, [selectedContact]);

  const getContactID = async () => {
    getContactByID(idContact).then((response) => {
      if (response.status === 200) {
        console.log(response.data)
        setSelectContact(response.data)
        setTimeout(() => {
          setLoading(false);
        }, 500);
      } else {
        console.log(response)
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    if (idContact) {
      setLoading(true)
      getContactID()
    }
  }, [idContact]);


  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const visibleVerMas = (currentPage, totalPages) => {
    if (currentPage < totalPages) {
      setVerMas(true);
    } else {
      setVerMas(false)
    }
  };

  const getContacts = async (buscador) => {
    setLoading2(true);
    getAllSeguimientos({
      page: currentPage,
      perPage: buscador ? null : 30,
      filterBy: buscador,
      userId: user.id,
      userType: user.type,
      seguimientoStatus: filterStatusList
    }).then((response) => {
      if (response?.status === 200) {
        if (buscador) {
          const newContacts = [...contacts, ...response.data.seguimientos];
          setContactsFilter(response.data.seguimientos)
          setUltimaPaginaSolicitada(response.data.page)
          setTotalcontactViewer(response.data.total)
          setTotalPages(Math.ceil(response.data.total));
          setLoading2(false)
        }
        else if (filterStatusList !== "Todos") {
          const newContacts = [...contacts, ...response.data.seguimientos];
          setUltimaPaginaSolicitada(response.data.page)
          setContacts(response.data.seguimientos)
          setTotalcontactViewer(response.data.total)
          setTotalPages(Math.ceil(response.data.total / 30));
          setLoading2(false)
        }
        else {
          const newContacts = [...contacts, ...response.data.seguimientos];
          setUltimaPaginaSolicitada(response.data.page)
          setContacts(newContacts);
          setTotalcontactViewer(response.data.total)
          setTotalPages(Math.ceil(response.data.total / 30));
          setLoading2(false)
        }
      } else {
        setLoading2(false)
      }
    });
  };


  useEffect(() => {
    setLoading2(true)
    getContacts(buscador)
  }, [currentPage, buscador, filterStatusList]);
  useEffect(() => {
    setCurrentPage(1)
  }, [filterStatusList]);
  useEffect(() => {
    visibleVerMas(currentPage, totalPages)
  }, [currentPage, totalPages]);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    const handleScroll = () => {
      if (scrollContainer.scrollHeight - parseInt(scrollContainer.scrollTop) === scrollContainer.clientHeight) {
        visibleVerMas(currentPage, totalPages);
      }
    };
    scrollContainer.addEventListener('scroll', handleScroll);
    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [totalPages, currentPage, buscador, scrollContainerRef.current]);


  const handlerOpenModal = () => {
    setOpenModal(true);
  }
  const handlerOpenModalSeguimiento = () => {
    setOpenModalAddSeguimiento(true);
  }
  const handlerOpenModalObservaciones = () => {
    setOpenModalObservaciones(true);
  }
  const closeModalObservaciones = () => {
    setOpenModalObservaciones(false);
  }
  const closeModal = () => {
    setOpenModal(false);
  }
  const closeModalAddSeguimiento = () => {
    setOpenModalAddSeguimiento(false);
  }

  const handleChangeBuscador = (e) => {
    const { name, value } = e.target;
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
    setBuscador(value);
  };

  return (

    <ContainerBox >
      <DivContentFilters params={params}>
        <DivRow>
          <DivColumn1>

            <Text1>{`Total: ${totalcontactViewer ? totalcontactViewer : 0}`}</Text1>
          </DivColumn1>
        </DivRow>
        <DivRow1>
          <ItemAux style={{
            opacity: filterStatusList === "Todos" ? 1 : 0.5,
            justifyContent: "center",
            cursor: "pointer",
          }}
            onClick={() => SetFilterStatusList("Todos")}
          >
            <CircleItem
              style={{
                backgroundColor: "#003049",
              }}
            />
            <TextItem>
              Todos
            </TextItem>
          </ItemAux>
          <ItemAux style={{
            opacity: filterStatusList === "No le interesa" ? 1 : 0.5,
            justifyContent: "center",
            cursor: "pointer",
          }}
            onClick={() => SetFilterStatusList("No le interesa")}
          >
            <CircleItem
              style={{
                backgroundColor: "#911813",
              }}
            />
            <TextItem>
              No le interesa
            </TextItem>
          </ItemAux>
          <ItemAux style={{
            opacity: filterStatusList === "Esperando Respuesta" ? 1 : 0.5,
            justifyContent: "center",
            cursor: "pointer",
          }}
            onClick={() => SetFilterStatusList("Esperando Respuesta")}
          >
            <CircleItem
              style={{
                backgroundColor: "#e8be01",
              }}
            />
            <TextItem>
              Esp. Resp
            </TextItem>
          </ItemAux>
          <ItemAux style={{
            borderRadius: "8px",
            opacity: filterStatusList === "Esperando Datos" ? 1 : 0.5,
            justifyContent: "center",
            cursor: "pointer",
          }}
            onClick={() => SetFilterStatusList("Esperando Datos")}
          >
            <CircleItem
              style={{
                backgroundColor: "#3bc15e",
              }}
            />
            <TextItem>
              Esp. Datos
            </TextItem>
          </ItemAux>
        </DivRow1>
        <Input
          type="text"
          placeholder="Buscar..."
          value={buscador}
          onChange={handleChangeBuscador}
        />
        <ScrollContainer ref={scrollContainerRef} >
          {contacts && contacts.length > 0 && !buscador ?
            (
              <>
                {contacts.map((contact, index) => (
                  <CardSeguimiento
                    key={index}
                    contact={contact}
                    handlerOpenModalObservaciones={handlerOpenModalObservaciones}
                    handlerOpenModal={handlerOpenModal}
                    formData={formData}
                    setFormData={setFormData}
                    setSelectContact={setSelectContact}
                    selectedContact={selectedContact}
                    setIdContact={setIdContact}

                  />
                ))}
              </>
            ) : (
              <>
                {!buscador ?
                  <Text style={{ textAlign: 'center' }}>No se encontraron resultados.</Text> : null
                }
              </>
            )
          }
          {buscador && contactsFilter && contactsFilter.length > 0 ?
            (
              <>
                {contactsFilter.map((contact, index) => (
                  <CardSeguimiento
                    key={index}
                    contact={contact}
                    handlerOpenModalObservaciones={handlerOpenModalObservaciones}
                    handlerOpenModal={handlerOpenModal}
                    formData={formData}
                    setFormData={setFormData}
                    setSelectContact={setSelectContact}
                    selectedContact={selectedContact}
                    setIdContact={setIdContact}
                  />
                ))}
              </>
            ) : (
              <>
                {buscador ?
                  <Text style={{ textAlign: 'center' }}>No se encontraron resultados.</Text> : null
                }
              </>
            )
          }
        </ScrollContainer>
        {
          verMas ?
            <BtnVerMas onClick={handleNextPage}>
              Ver mas
            </BtnVerMas>
            : null
        }
      </DivContentFilters>
      <DivFlexColumn params={params} >
        {
          openAddContact ?
            <AgregarContacto
              openAddContact={openAddContact}
              setOpenAddContact={setOpenAddContact}
            />
            : null
        }
        {
          loading === false && selectedContact?.id !== undefined ? (
            <DetailContact
              selectedContact={selectedContact}
              formData={formData}
              handlerOpenModal={handlerOpenModal}
              handlerOpenModalObservaciones={handlerOpenModalObservaciones}
              openModalObservaciones={openModalObservaciones}
              openModal={openModal}
              handlerOpenModalSeguimiento={handlerOpenModalSeguimiento}
              closeModalObservaciones={closeModalObservaciones}
              closeModal={closeModal}
              setSeActualizoContacto={setSeActualizoContacto}
              getContacts={getContacts}
              getContactID={getContactID}
              scrollContainerRef={scrollContainerRef}
              setContacts={setContacts}
              closeModalAddSeguimiento={closeModalAddSeguimiento}
              openModalAddSeguimiento={openModalAddSeguimiento}
              user={user}
            />
          ) : loading === false && !selectedContact?.id ? (
            <DivBoxContainer>
              <VideoCont muted autoPlay loop src={test} />
            </DivBoxContainer>
          ) : (
            <CustomCircularProgress size={50} padding='15vw' />
          )
        }
      </DivFlexColumn>
    </ContainerBox>

  );
};

export default Seguimientos;